/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { useFormikContext } from 'formik';
import { BsCalendar } from 'react-icons/bs';
import { Col, Row } from 'react-bootstrap';
import {
  Button,
  ContentCard,
  SelectGeneric,
  TextArea,
  DateInput,
  Input
} from 'ypf-pas-general-ui-components';

import { getServicesWell } from '../../../services/yclickMaster';
import { stepEnum, stepEnumOfAccordion } from '../Constants';
import { RequestErrors, RequestField, RequestTouched, RequestValue } from '../CreateServiceProps';
import useLoadServices from '../../../hooks/useLoadServices';

const actualYear = new Date().getFullYear();
const actualMonth = new Date().getMonth() + 1;
const actualDay = new Date().getDate();
const justifyMonth = actualMonth.toString().length === 1 ? `0${actualMonth}` : actualMonth;
const justifyDay = actualDay.toString().length === 1 ? `0${actualDay}` : actualDay;

const actualDate = `${actualYear}-${justifyMonth}-${justifyDay}`;

const fetchServices = async (value, idEvento) => {
  if (value.length < 3) return null;

  const servicesWell = await getServicesWell(value, idEvento);

  return servicesWell;
};

const serviceInvalid = (requestErrors, requestTouched, isDateAndServiceDuplicated) =>
  (requestErrors?.service?.service && requestTouched?.service?.service) ||
  isDateAndServiceDuplicated;

const probDateInvalid = (requestErrors, requestTouched, isDateAndServiceDuplicated) =>
  (requestErrors?.service?.probDate && requestTouched?.service?.probDate) ||
  isDateAndServiceDuplicated;

const needDateInvalid = (requestErrors, requestTouched) =>
  requestErrors?.service?.needDate && requestTouched?.service?.needDate;

const descriptionInvalid = (requestErrors, requestTouched) =>
  requestErrors?.service?.description && requestTouched?.service?.description;

const buttonContinueDisabled = (values, requestErrors, isValidPriority) =>
  values.isOyM ? !!requestErrors?.service || !isValidPriority : !!requestErrors?.service;

const ServiceForm = ({
  resetField,
  isApplyTemplateRequest,
  accordionIndex,
  setStep,
  step,
  requestValue,
  requestField,
  requestErrors,
  requestTouched,
  backToUbicationForm,
  disabledAllFields
}) => {
  const [dateProb, setDateProb] = useState(null);
  const { values, setFieldValue, setFieldTouched, touched } = useFormikContext();
  const containerRef = useRef();

  const { prioritySelect } = useLoadServices({});

  const serviceField = `accordions[${accordionIndex}].service`;
  const serviceValue = values?.accordions[accordionIndex].service;

  const isDateAndServiceDuplicated = typeof requestErrors?.service === 'string';
  const isValidPriority = !!values?.accordions[accordionIndex].service.priority;

  const isServiceInvalid = serviceInvalid(
    requestErrors,
    requestTouched,
    isDateAndServiceDuplicated
  );
  const isProbDateIvalid = probDateInvalid(
    requestErrors,
    requestTouched,
    isDateAndServiceDuplicated
  );
  const isNeedDateInvalid = needDateInvalid(requestErrors, requestTouched);
  const isDescriptionInvalid = descriptionInvalid(requestErrors, requestTouched);
  const isButtonContinueDisabled = buttonContinueDisabled(values, requestErrors, isValidPriority);

  const serviceFieldErrors = isDateAndServiceDuplicated
    ? requestErrors?.service
    : requestErrors?.service?.service;

  const probDateFieldErrors = isDateAndServiceDuplicated
    ? requestErrors?.service
    : requestErrors?.service?.probDate;

  const handleChangeService = async (val) => {
    setFieldValue('changeDependencieApprover', values.changeDependencieApprover + 1);
    if (val?.id !== serviceValue?.service?.id) {
      setFieldValue(`${serviceField}.service`, val);
      setFieldTouched(`${serviceField}.service`);
      // Aca termina la logica del handleChangeService

      requestValue?.provider?.providers?.forEach((_, index) => {
        resetField(
          requestValue?.provider?.providers[index]?.contract,
          `${requestField}.providers[${index}].contract`,
          null
        );
      });
      // eslint-disable-next-line react/prop-types
      resetField(
        requestValue?.associatedUsers?.approvers.length,
        `${requestField}.associatedUsers.approvers`,
        []
      );
      if (requestValue?.provider?.providers.length) {
        setFieldValue(`${requestField}.provider.providers`, [
          {
            provider: null,
            contract: null,
            notificate: null,
            businessUnit: values.ubication.uunn
          }
        ]);
      }
    }
    setStep(stepEnumOfAccordion.service);
  };

  useEffect(() => {
    if (step === stepEnumOfAccordion.service) {
      containerRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }

    setFieldValue(`${requestField}.accordionStep`, stepEnumOfAccordion.service);
  }, [step]);

  return (
    <div ref={containerRef}>
      <ContentCard
        mark={
          values.currentStep >= stepEnum.services && step === stepEnumOfAccordion.service
            ? 'primary'
            : 'none'
        }
        orientation="horizontal-vertical"
      >
        <Row>
          <Col sm={12}>
            <SelectGeneric
              async
              errors={serviceFieldErrors}
              fetchData={(value) =>
                fetchServices(
                  value,
                  values.isOyM
                    ? values.ubication.ubicationType?.tipoNegocio?.evento?.id
                    : values.ubication.event?.id
                )
              }
              isDisabled={disabledAllFields}
              isInvalid={isServiceInvalid}
              label="Servicio"
              name={`${requestField}.service`}
              onChange={handleChangeService}
              paddingIndicator={4}
              placeholder="Buscar por nombre. Ingrese al menos 3 caracteres"
              value={serviceValue?.service}
              withSelect="100%"
            />
          </Col>
        </Row>
        <Row className="mt-3 mb-4">
          <Col sm={values.isOyM ? 4 : 6}>
            {values.isTemplate ? (
              <Input disabled disabledIcon icon={<BsCalendar />} value="--/--/--" />
            ) : (
              <DateInput
                disabled={disabledAllFields}
                errors={probDateFieldErrors}
                isInvalid={isProbDateIvalid}
                label="Fecha probable de realización"
                min={actualDate}
                name={`${serviceField}.probDate`}
                onChange={async (e) => {
                  const val = e.target.value;

                  setFieldValue(`${serviceField}.probDate`, val);
                  setFieldTouched(`${serviceField}.probDate`);
                  await resetField(values?.service?.needDate, `${serviceField}.needDate`, '');
                  setDateProb(val);
                  if (!isApplyTemplateRequest) setStep(stepEnumOfAccordion.service);
                }}
                placeholder="Selecciona una fecha"
                value={serviceValue.probDate}
                widthDateInput="100%"
              />
            )}
          </Col>
          <Col sm={values.isOyM ? 4 : 6}>
            {values.isTemplate ? (
              <Input disabled disabledIcon icon={<BsCalendar />} value="--/--/--" />
            ) : (
              <DateInput
                disabled={disabledAllFields}
                errors={requestErrors?.service?.needDate}
                isInvalid={isNeedDateInvalid}
                label="Fecha de necesidad de respuesta"
                max={dateProb}
                min={actualDate}
                name={`${serviceField}.needDate`}
                onChange={async (e) => {
                  setFieldValue(`${serviceField}.needDate`, e.target.value);
                  setFieldTouched(`${serviceField}.needDate`);
                  if (!isApplyTemplateRequest) setStep(stepEnumOfAccordion.service);
                }}
                placeholder="Selecciona una fecha"
                value={serviceValue.needDate}
                widthDateInput="100%"
              />
            )}
          </Col>
          {values.isOyM && (
            <Col sm={4}>
              <SelectGeneric
                errors="Seleccione una prioridad"
                isDisabled={disabledAllFields}
                isInvalid={
                  !!touched?.accordions && touched?.accordions[accordionIndex]?.service?.priority
                    ? !isValidPriority
                    : false
                }
                label="Prioridad"
                name={`${serviceField}.priority`}
                onChange={(value) => {
                  setFieldTouched(`${serviceField}.priority`);
                  setFieldValue(`${serviceField}.priority`, value);
                }}
                options={prioritySelect}
                paddingIndicator={4}
                placeholder="Seleccione prioridad"
                value={serviceValue?.priority}
                withSelect="100%"
              />
            </Col>
          )}
        </Row>
        <Row>
          <Col sm={12}>
            <TextArea
              disabled={disabledAllFields}
              errors={requestErrors?.service?.description}
              isInvalid={isDescriptionInvalid}
              label="Descripción"
              maxLength={512}
              name={`${serviceField}.description`}
              onChange={(e) => {
                if (!requestTouched?.service.description) {
                  setFieldTouched(`${serviceField}.description`);
                }

                setFieldValue(`${serviceField}.description`, e.target.value);

                if (requestValue?.accordionStep !== stepEnumOfAccordion.service) {
                  setStep(stepEnumOfAccordion.service);
                }
              }}
              placeholder="Detalla el servicio a solicitar"
              value={serviceValue?.description}
            />
          </Col>
        </Row>
        {step === 2 && (
          <>
            <hr />
            <div className="gap row justify-content-end">
              <Button
                label="Cancelar"
                onClick={() => {
                  setFieldValue(`${serviceField}.service`, '');
                  setFieldValue(`${serviceField}.probDate`, '');
                  setFieldValue(`${serviceField}.needDate`, '');
                  setFieldValue(`${serviceField}.description`, '');
                  setFieldValue(`${serviceField}.priority`, '');
                  setFieldTouched(`${serviceField}.service`, false);
                  setFieldTouched(`${serviceField}.probDate`, false);
                  setFieldTouched(`${serviceField}.needDate`, false);
                  setFieldTouched(`${serviceField}.description`, false);
                  setFieldTouched(`${serviceField}.priority`, false);
                  backToUbicationForm();
                }}
                type="button"
                variant="outline-primary"
              />
              <Button
                disabled={isButtonContinueDisabled}
                label="Continuar"
                onClick={() => {
                  setStep(stepEnumOfAccordion.provider);
                }}
                type="button"
                variant="primary"
              />
            </div>
          </>
        )}
      </ContentCard>
    </div>
  );
};

ServiceForm.propTypes = {
  accordionIndex: PropTypes.number.isRequired,
  disabledAllFields: PropTypes.bool,
  serviceValue: PropTypes.shape({
    service: PropTypes.string,
    probDate: PropTypes.string,
    needDate: PropTypes.string,
    description: PropTypes.string
  }),
  step: PropTypes.number.isRequired,
  setStep: PropTypes.func.isRequired,
  requestErrors: RequestErrors,
  requestField: RequestField.isRequired,
  requestTouched: RequestTouched,
  requestValue: RequestValue,
  resetField: PropTypes.func.isRequired,
  backToUbicationForm: PropTypes.func.isRequired,
  isApplyTemplateRequest: PropTypes.bool
};

ServiceForm.defaultProps = {
  disabledAllFields: false,
  serviceValue: {},
  requestTouched: {},
  requestErrors: {},
  requestValue: {},
  isApplyTemplateRequest: false
};

export default ServiceForm;
